import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import { UseFilterValuesType } from '@/components/FilterNew/types';
import { useStatusesQuery } from '@/modules/tasks/views/TaskStasusesManager/graphql/queries/generated/statuses';
import {
  APPLICABLE_ON_FILTER,
  SORT_BY,
} from '@/modules/tasks/views/TaskStasusesManager/hooks/useStatuses';

import useFilterValue from '../../hooks/useFilterValue';
import useTaskStatusOptionsQuery from './useTaskStatusOptionsQuery';
import { getTaskStatusFilterOption } from './utils';

const useFilterValues: UseFilterValuesType = ({ value }) =>
  useFilterValue({
    value,
    useQuery: useStatusesQuery,
    edgeKey: 'statuses',
    variables: {
      filters: {
        statusIds: value,
        excludeEntityStatuses: true,
        applicableOn: APPLICABLE_ON_FILTER,
      },
      sort: SORT_BY,
    },
    getFilterOption: getTaskStatusFilterOption,
  });

export const TaskStatusEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery: useTaskStatusOptionsQuery,
  useFilterValues,
};
